import React, { useState, useRef } from 'react';
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import { generateWord } from 'quill-to-word';
import { saveAs } from 'file-saver';
import PreviewFile from "./components/preview";

const Delta = Quill.import('delta');


const InfoFile = (props) => {

    // CONFIG
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['video', 'image', 'blockquote', 'code-block', 'link'],

            ["formula"],

            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, false] }],

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            [{ 'align': [] }],

            ['clean'],
        ],
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: false
        }
    };

    // OBJECT
    const [fileName, setFileName] = useState('information_document');

    // MODE
    const [modeClear, setModeClear] = useState(false);

    // CONTENT
    const [content, setContent] = useState(props.init);
    const quillRef = useRef(null); // Ref to access Quill instance

    const handleContentChange = (value, delta, source, editor) => {
        setContent(value);
    };

    // CLEAR
    const clearContent = () => {
        setFileName('')
        setContent(props.init)
    }

    // EXPORT
    const exportToWord = async () => {

        const quillToWordConfig = {
            exportAs: 'blob'
        };

        if (quillRef.current) {
            const quill = quillRef.current.getEditor();

            quill.format('color', 'black');

            // ADD TITLE PAGE
            quill.updateContents(new Delta()
                .insert('Інформаційна довідка\n', {
                    // header: 1,
                    bold: true,
                    align: 'center'
                })
                .insert(`на об'єкт ${fileName.toUpperCase()}\n`, {
                    bold: true,
                    align: 'center',
                })
                .retain(0)
            );

            const delta = quill.getContents();

            try {
                const blob = await generateWord(delta, quillToWordConfig);
                saveAs(blob, `${fileName}.docx`);

                modeClear && clearContent();

            } catch (error) {
                console.error('Error generating Word document:', error);
            }
        }
    };

    return (
        <div>
            <div className="header d-flex justify-content-between align-content-start border-bottom pb-2">
                <div>
                    <h1>
                        Інформаційна довідка
                    </h1>
                    <small className="text-muted d-flex">
                        <input type="text"
                               placeholder={"Назва об'єкту"}
                               onChange={(e) => setFileName(e.target.value)} className={'form-control'}/>
                    </small>
                </div>
                <div className={'d-flex'}>
                    <div className={'p-2 border-end'}>
                        <small className="text-muted m-1">
                            <b>Експорт</b>
                        </small> <br/>
                        <div id={'export-btn'} className="d-flex">
                            <button type={'button'} onClick={exportToWord}
                                    className={'btn btn-dark m-1'}>
                                Word
                            </button>
                            <PreviewFile name={fileName} content={content} />
                        </div>
                    </div>
                    <div className={'p-2'}>
                        <small className={'text-muted'}>
                            <b>Опція</b>
                        </small>
                        <br/>
                        <div className="d-flex justify-content-between align-items-start">

                            <div className={'align-items-center d-flex'}>
                                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                     viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"/>
                                </svg>
                                <small className="text-secondary p-1">
                                   <b>Очищення</b>
                                    {/*{modeClear ? ' Вкл.' : ' Викл.'}*/}
                                </small>
                            </div>

                            <input type="checkbox" id="toggleClear" className="checkbox"
                                   onChange={() => setModeClear(!modeClear)}/>

                            <label htmlFor="toggleClear" className="switch mt-1"></label>

                        </div>
                        {/*<br/>*/}
                        <small className={'text-muted'} style={{fontSize: '10px'}}>
                            Очищення полів після завантаження Word
                        </small>
                    </div>
                </div>
            </div>

            <ReactQuill
                ref={quillRef}
                theme="snow"
                modules={modules}
                value={content}
                onChange={handleContentChange}
            />
        </div>
    );
};

export default InfoFile;